var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-7",attrs:{"width":"80%"}},[_c('v-card-text',[_c('v-container',[_c('div',{staticClass:"text-h4"},[_vm._v("Order Finalization")]),_c('v-btn',{staticClass:"mt-2",attrs:{"color":"success","loading":_vm.isLoading,"disabled":_vm.isDisabled},on:{"click":_vm.submitOrder}},[_vm._v(" Submit Order ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }